import Vue from 'vue';
import VueRouter from 'vue-router';
import main from '@/views/main';
import account from '@account/index';
import home from '@home/index';
import login from '@login/index';
import reconciliation from '@reconciliation/index';
import setUp from '@set-up/index';
import statistics from '@statistics/index';
import trading from '@trading/index';
import apply from '@apply/index';
import merchants from '../views/merchants/store';
Vue.use(VueRouter);

const routes = [
  ...login,
  ...apply,
  {
    path: '/',
    redirect: 'login',
    component: main,
    children: [...account, ...home, ...reconciliation, ...setUp, ...statistics, ...trading, ...merchants],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/**
 * @description 路由守卫
 */
/* 路由拦截器 */
router.beforeEach((to, from, next) => {
  // 跳转页面----to
  if (to.matched.some(route => route.meta.auth)) {
    // 判断是否已经登录
    if (localStorage.getItem('loginUesr')) {
      next();
    } else {
      // 跳转到登录
      next({
        path: '/login',
      });
    }
  } else {
    next();
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

router.afterEach(() => {
  return;
});

export default router;
